import featureFlags from '~/constants/FeatureFlags';

export function getActiveTests(store) {
  let config = store.getState().config;
  let tests = config.get('signals');
  let activeTests = Object.keys(featureFlags).filter(key => {
    const flags = featureFlags[key].flags;
    return !Object.keys(flags).some(group => flags[group] === 1);
  });
  const filtered = activeTests.reduce(
    (obj, key) => ({...obj, [key]: tests[key]}),
    {}
  );
  return filtered;
}

export function noop() {}
